import React from 'react';
import { Text } from '@amzn/atoz-web/Text';
import { View } from '@amzn/atoz-web/View';
import { Spinner, SpinnerSize } from '@amzn/atoz-web/Spinner';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { useTranslation } from 'react-i18next';
export var PageSpinner = function (_a) {
    var dataTestId = _a.dataTestId, text = _a.text;
    var t = useTranslation().t;
    return (React.createElement(Wrapper, null,
        React.createElement(SpinnerContainer, null,
            React.createElement(Spinner, { dataTestId: dataTestId || 'PageSpinner', size: SpinnerSize.Medium }),
            React.createElement(StyledText, null, text || t('shift_management_common_loading')))));
};
var Wrapper = styledWithTheme(View)(function () { return "\n    margin-top: 30%;\n  "; });
var SpinnerContainer = styledWithTheme(View)(function () { return "\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    top: 30%;\n  "; });
var StyledText = styledWithTheme(Text)(function (_a) {
    var theme = _a.theme;
    return "\n    font-weight: bold;\n    margin-top: ".concat(theme.selectors.space('S300'), "px;\n  ");
});
